<template>
  <div id="app" class="wrapper">
    <div
      class="l-wrapper"
      :style="$route.fullPath.includes('itinerary') && $route.fullPath.includes('invoice/shared') && $route.fullPath.includes('invoice/payment/result') ? {paddingTop: '0px'} : {}">
      <Header
        v-if="!$route.fullPath.includes('itinerary') && !$route.fullPath.includes('invoice/payment/result')"
        :mode="$route.fullPath.includes('marsel') || $route.fullPath.includes('invoice/shared') || $route.fullPath.includes('invoice/payment/result') ? 'min' : 'full'"
        @logoutUser="logoutUser"
        :user="user" />
      <router-view
        v-if="
          $route.fullPath.includes('marsel') ||
          $route.fullPath.includes('itinerary') ||
          $route.fullPath.includes('invoice/shared')
            ? true
            : user && loaded
        "
        :user="user"
        @setUser="setUser"
        @logoutUser="logoutUser"
        @confirmed="confirmed"
        @errored="errored"
        @deleteModalHandler="deleteModalHandler"
        @notLeaveHandler="notLeaveHandler"
        @changeImage="showFileChooser"
        :uploadedFile="uploadedFile"
        @notLeavePopupHandler="notLeavePopupHandler"
        @waitSaveHandler="waitSaveHandler"
        :key="componentKey"
        @forceRerender="forceRerender"
        :referer="referer" />
      <Footer v-if="!$route.fullPath.includes('itinerary') || !$route.fullPath.includes('invoice/payment/result')"/>
    </div>
    <input
      :style="{display: 'none'}"
      ref="input"
      type="file"
      name="image"
      accept="image/*"
      @change="changeImage" />
    <div class="modal-wrapper" v-if="confirm" :style="{zIndex: 200}">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="modal-body">
          <div class="modal-body__icon">
            <svg width="1em" height="1em" class="icon icon-check-rounded">
              <use
                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check-rounded"></use>
            </svg>
          </div>
          <span class="modal-body__title">Changes Saved!</span>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="error" :style="{zIndex: 200}">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="modal-body">
          <div class="modal-body__icon">
            <svg width="1em" height="1em" class="icon icon-error">
              <use
                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-error"></use>
            </svg>
          </div>
          <span class="modal-body__title">Something went wrong</span>
          <span class="modal-body__subtitle">{{ errorText }}</span>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="deleteModal" :style="{zIndex: 300}">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup info-popup_park info-popup_park_2">
          <div class="edit-popup__header">
            <div class="info-title">
              <div class="info-title__icon">
                <svg width="3rem" height="3rem">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-error"></use>
                </svg>
              </div>
              <span class="info-title__heading"
                >Delete {{ deleteData.entity }}</span
              >
            </div>
            <div class="edit-popup__close" @click="deleteModal = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="info-popup__text">
            <p>
              Are you sure you want to delete {{ deleteData.name }}
              {{ deleteData.entity }}?
            </p>
          </div>
          <div class="edit-popup__btns-2 edit-popup__btns--park">
            <button
              type="button"
              class="btn btn--green"
              @click="deleteModal = false">
              <span>No, go back</span>
            </button>
            <button
              type="button"
              class="btn btn--red"
              @click="
                deleteData.handler(deleteData.id)
                deleteModal = false
              ">
              <span>Yes, delete</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="leave" :style="{zIndex: 200}">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup info-popup info-popup_actions">
          <div class="edit-popup__header">
            <div class="info-title">
              <div class="info-title__icon">
                <svg width="3rem" height="3rem">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#info-actions-icon"></use>
                </svg>
              </div>
              <span class="info-title__heading"
                >It looks like you have been editing something</span
              >
            </div>
            <div
              class="edit-popup__close"
              @click="
                leave = false
                isLeave = false
              ">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="info-popup__text">
            <p>
              If you leave before saving, your changes will be lost. Are you
              sure you want to leave?
            </p>
          </div>
          <div class="info-popup__btns">
            <button
              type="button"
              class="btn btn--silver"
              @click="
                isLeave = false
                $router.push({
                  name: leaveTo.name,
                  params: {leave: true, ...leaveTo.params},
                })
                leave = false
              ">
              <span>Leave without saving</span>
            </button>
            <button
              type="button"
              class="btn btn--green btn--shadowed"
              @click="
                leave = false
                isLeave = false
              ">
              <span>Stay</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="leavePopup" :style="{zIndex: 200}">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup info-popup info-popup_actions">
          <div class="edit-popup__header">
            <div class="info-title">
              <div class="info-title__icon">
                <svg width="3rem" height="3rem">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#info-actions-icon"></use>
                </svg>
              </div>
              <span class="info-title__heading"
                >It looks like you have been editing something</span
              >
            </div>
            <div class="edit-popup__close" @click="leavePopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="info-popup__text">
            <p>
              If you leave before saving, your changes will be lost. Are you
              sure you want to leave?
            </p>
          </div>
          <div class="info-popup__btns">
            <button
              type="button"
              class="btn btn--silver"
              @click="
                leavePopup = false
                leavePopupData.handler()
              ">
              <span>Leave without saving</span>
            </button>
            <button
              type="button"
              class="btn btn--green btn--shadowed"
              @click="leavePopup = false">
              <span>Stay</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal-wrapper"
      :style="{
        zIndex: load ? 200 : -100,
        visibility: load ? 'visible' : 'hidden',
        opacity: load ? 1 : 0,
      }">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--picture-upload">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-photo">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-photo"></use>
                </svg>
              </div>
              <span>Upload a picture</span>
            </div>
            <div class="edit-popup__close" @click="load = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="edit-popup__photo-crop">
            <cropper
              ref="cropper"
              alt=" "
              :src="imgSrc"
              :aspect-ratio="16 / 9"
              :width="'100%'"
              :style="{maxHeight: '260px'}">
            </cropper>
            <!-- <croppa
              v-model="myCroppa"
              :width="498"
              :height="260"
              placeholder=""
              @file-choose="load = true"
            ></croppa> -->
          </div>
          <div class="edit-popup__footer">
            <div class="edit-popup__footer__side">
              <button
                type="button"
                class="btn btn-zoom"
                @click="$refs.cropper.relativeZoom(-0.2)">
                <svg width="1em" height="1em" class="icon icon-minus">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-minus"></use>
                </svg>
              </button>
              <button
                type="button"
                class="btn btn-zoom"
                @click="$refs.cropper.relativeZoom(0.2)">
                <svg width="1em" height="1em" class="icon icon-plus">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus"></use>
                </svg>
              </button>
              <button
                type="button"
                class="btn btn-rotate btn-rotate--right"
                @click="$refs.cropper.rotate(90)">
                <svg width="1em" height="1em" class="icon icon-rotate">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rotate"></use>
                </svg>
              </button>
              <button
                type="button"
                class="btn btn-rotate btn-rotate--left"
                @click="$refs.cropper.rotate(-90)">
                <svg width="1em" height="1em" class="icon icon-rotate">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rotate"></use>
                </svg>
              </button>
            </div>
            <div class="edit-popup__footer__side">
              <button
                type="button"
                class="btn btn--silver"
                @click="showFileChooser(typeRatio)">
                <span>Choose another photo</span>
              </button>
              <button type="button" class="btn btn--green" @click="upload">
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="wait_save" :style="{zIndex: 200}">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--verify">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="3rem" height="3rem">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#info-actions-icon"></use>
                </svg>
              </div>
              <span>Would you like to save changes?</span>
            </div>
            <div class="edit-popup__close" @click="waitSaveCloseHandler">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="text-verify">
            <span
              >You haven`t saved changes in last 10 minutes. <br />
              Would you like to save it now</span
            >
          </div>
          <div class="edit-popup__btns-2">
            <button
              type="button"
              class="btn btn--silver btn__verify"
              @click="waitSaveCloseHandler()">
              <span>No, remind me in 10 min</span>
            </button>
            <button
              type="button"
              class="btn btn--green btn__verify"
              @click="
                wait_save = false
                isSaveFun()
              ">
              <span>Yes, save now</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import 'assets/scss/main.scss';
.text-center {
  text-align: center;
}
</style>

<script>
import jwt_decode from 'jwt-decode'
import {
  logout,
  refresh,
  setUserRoles,
  deleteUserRoles,
  checkAuthToken,
  getMe,
  uploadUserImageWithCrop,
} from '@/utilites/api'

import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Croppa from 'vue-croppa'

import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

import './styles/print.css'
import './styles/all.css'
import './styles/all2.css'
import './styles/all3.css'
import './styles/all4.css'
import './styles/flag-icon.css'
import './styles/fancybox.css'
import './styles/itinerary.css'
import 'vue-croppa/dist/vue-croppa.css'
import './styles/custom.css'
import './styles/select.css'
import './styles/custom-tooltip.scss';

export default {
  name: 'App',
  data() {
    return {
      user: null,
      confirm: false,
      error: false,
      errorText: '',
      deleteModal: false,
      referer: '',
      deleteData: {
        entity: '',
        name: '',
        handler: () => false,
        id: null,
      },
      leave: false,
      componentKey: 0,
      leaveTo: '/',
      isLeave: false,
      leavePopup: false,
      load: false,
      myCroppa: {},
      uploadedFile: null,
      leavePopupData: {
        handler: () => false,
      },
      loaded: false,
      imgSrc: '',
      typeRatio: 'default',

      wait_save: false,
      isWaitFun: () => {},
      isSaveFun: () => {},
    }
  },
  mounted() {
    const title = document.getElementById('title')
    const faviconAppleTouchIcon = document.getElementById(
      'favicon-apple-touch-icon'
    )
    const favicon32 = document.getElementById('favicon-32x32')
    const favicon16 = document.getElementById('favicon-16x16')
    const BRANDING = process.env.VUE_APP_BRANDING
    
    if (BRANDING === 'false') {
      title.innerText = 'Altezza travel'

      if (this.$route.name === 'itinerary') {
        faviconAppleTouchIcon.setAttribute(
          'href',
          `${process.env.BASE_URL}favicon/second/apple-touch-icon.png`
        )
        favicon32.setAttribute(
          'href',
          `${process.env.BASE_URL}favicon/second/favicon.ico`
        )
        favicon16.setAttribute(
          'href',
          `${process.env.BASE_URL}favicon/second/favicon-16x16.png`
        )
      } else {
        faviconAppleTouchIcon.setAttribute(
          'href',
          `${process.env.BASE_URL}favicon/apple-touch-icon.png`
        )
        favicon32.setAttribute(
          'href',
          `${process.env.BASE_URL}favicon/favicon.ico`
        )
        favicon16.setAttribute(
          'href',
          `${process.env.BASE_URL}favicon/favicon-16x16.png`
        )
      }
    } else {
      title.innerText = 'Luxury Short Safari'
      faviconAppleTouchIcon.setAttribute(
        'href',
        `${process.env.BASE_URL}favicon/LSS-favicon-apple-touch-icon.png`
      )
      favicon32.setAttribute(
        'href',
        `${process.env.BASE_URL}favicon/LSS-favicon.ico`
      )
      favicon16.setAttribute(
        'href',
        `${process.env.BASE_URL}favicon/LSS-favicon-16x16.png`
      )
    }

    if (!window.location.pathname.includes('itinerary') && !window.location.pathname.includes('invoice/shared') && !window.location.pathname.includes('invoice/payment/result')) {
      this.$router.beforeEach((to, from, next) => {
        if (to.fullPath === '/marsel') {
          this.referer = from.fullPath
        }
        this.leaveTo = to
        let time = localStorage.getItem('expires')
        if (time) {
          time = +time
        }
        if (this.isLeave) {
          this.leave = true
          if (to.params.leave) {
            this.isLeave = false
            next()
          } else {
            next(false)
          }
        } else {
          next()
        }
      })
      checkAuthToken()
        .then(async (res) => {
          if (!res) {
            this.$router.push('/marsel')
          } else {
            let decode = jwt_decode(res.access_token)
            if (!window.location.pathname.includes('marsel')) {
              getMe(decode.sub).then((user) => {
                this.setUser({
                  ...res,
                  id: +decode.sub,
                  data: user,
                })
              })
            }
          }
        })
        .catch((error) => {
          this.$router.push('/marsel')
        })
      window.addEventListener('click', (event) => {
        if (!event.target.closest('.modal-body')) {
          this.confirm = false
          this.error = false
        }
      })
    }
  },
  components: {Footer, Header, croppa: Croppa.component, cropper: VueCropper},
  methods: {
    forceRerender() {
      this.componentKey += 1
    },
    notLeaveHandler() {
      this.isLeave = true
    },
    notLeavePopupHandler(data) {
      this.leavePopupData = {
        handler: data.handler,
      }
      this.leavePopup = true
    },
    setUser(data) {
      if (data) {
        this.user = data
        setUserRoles(data.scope)
        // setAuthData(JSON.stringify(data))
        localStorage.setItem(
          'expires',
          +new Date().getTime() + +data.expires_in * 1000
        )
        setTimeout(() => {
          this.loaded = true
        }, 500)
      }
    },
    logoutUser() {
      logout(this.user.refresh_token).then((res) => {
        this.user = null
        deleteUserRoles()
        this.$router.push('/marsel')
      })
    },
    refresHandler() {
      refresh(this.user.access_token, this.user.refresh_token)
        .then((res) => {
          this.setUser({
            ...this.user,
            ...res,
          })
        })
        .catch(() => {
          this.$router.push('/marsel')
        })
    },
    confirmed() {
      this.confirm = true
      setTimeout(() => {
        this.confirm = false
      }, 1000)
    },
    errored({text, time = 2000}) {
      this.error = true
      this.errorText = text
      setTimeout(() => {
        this.error = false
      }, time)
    },
    deleteModalHandler(data) {
      if (data.isOpenModal) {
        this.deleteModal = true
        this.deleteData = {
          entity: data.entity,
          name: data.name,
          handler: data.handler,
          id: data.id,
        }
      }
      if (!data.isOpenModal) {
        this.deleteData = {
          entity: data.entity,
          name: data.name,
          handler: data.handler,
          id: data.id,
        }
        this.deleteData.handler(this.deleteData.id)
      }
    },
    changeRatio() {
      if (this.typeRatio === 'circle') {
        document.querySelector('.cropper-view-box').style.borderRadius = '50%'
      } else {
        document.querySelector('.cropper-view-box').style.borderRadius = '0%'
      }
    },
    changeImage(e, mode) {
      // console.log('>> changeImage:', e)
      // console.log('>> changeImage  window.location.pathname:',  window.location.pathname)
      if (
        window.location.pathname.includes('climbing/routes') ||
        window.location.pathname.includes('safari/parks') ||
        window.location.pathname.includes('settings/location')
      ) {
        this.$refs.cropper.setAspectRatio()
      }
      const file = e.target.files[0]
      if (file.type.indexOf('image/') === -1) {
        return
      }
      this.load = true
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgSrc = event.target.result
          this.$refs.cropper.replace(event.target.result)
          this.load = true
          setTimeout(() => {
            this.changeRatio()
          }, 100)
        }
        reader.readAsDataURL(file)
      } else {
        // alert('Sorry, FileReader API not supported');
      }
    },
    showFileChooser(type) {
      this.$refs.input.click()
      this.typeRatio = type
      if (type === 'circle') {
        this.$refs.cropper.setAspectRatio(4 / 4)
      } else if (type === 'circle-spec') {
        this.$refs.cropper.setAspectRatio(0 / 0)
      } else if (type === 'itinerary') {
        this.$refs.cropper.setAspectRatio(22 / 9.1)
      } else if (type === 'hotel') {
        this.$refs.cropper.setAspectRatio(13.4 / 9)
      } else if (type === 'plane') {
        this.$refs.cropper.setAspectRatio(1 / 1)
      } else {
        this.$refs.cropper.setAspectRatio(16 / 9)
      }
    },
    upload() {
      // if (!this.myCroppa.hasImage()) {
      // 	return
      // }
      if (!this.imgSrc) {
        return
      }
      // console.log(this.$refs.cropper.src)
      // this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
      //   var fd = new FormData()
      //   fd.append('file', blob, 'filename.jpg')
      //   uploadUserImageWithCrop(fd).then((res) => {
      //     this.uploadedFile = res.id
      //     this.load = false
      //   })
      // }, 'image/jpeg')
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        var fd = new FormData()
        fd.append('file', blob, 'filename.png')
        uploadUserImageWithCrop(fd).then((res) => {
          this.uploadedFile = res.id
          this.load = false
        })
      }, 'image/png')
    },
    waitSaveHandler(callBack = []) {
      this.isSaveFun = callBack[0]
      this.isWaitFun = callBack[1]
      this.wait_save = true
    },
    waitSaveCloseHandler() {
      this.isWaitFun()
      this.wait_save = false
      setTimeout(() => {
        this.isSaveFun = () => {}
        this.isWaitFun = () => {}
      }, 100)
    },
  },
  watch: {
    load() {
      if (!this.load) {
        this.$refs.cropper.reset()
        this.$refs.input.value = ''
        // this.myCroppa.remove()
      }
    },
  },
}
</script>
